<template>
  <div
    id="myModal"
    class="modal"
    style="display: block"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">
            Modal Heading
          </h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="$emit('close')"
          >
            ×
          </button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <slot />
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="$emit('close')"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { showModel: false };
  },
};
</script>
